import React from "react";
import styles from "./Inventory.module.css";
import { List } from "antd";
import { useTranslation } from "react-i18next";

const Inventory = (data) => {
  const Data = data?.data?.state?.data
  const { t } = useTranslation();
  console.log('Data',Data)

  return (
    <div className={styles.mainContainer}>
      <List
        dataSource={Data?.inventories}
        renderItem={(item, index) => {
          console.log('item',item)

          return (
            <div className={styles.item}>
              <div>
                <h1 className={styles.heading}>{item?.name}</h1>
              </div>

              <div className={styles.flexC}>
                <h2 className={styles.sub_heading}>{item?.quantity}</h2>
                <h4 className={styles.text}>{t("Total")}</h4>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default Inventory;
